import { render, staticRenderFns } from "./SettingsForm.vue?vue&type=template&id=79244c67&"
import script from "./SettingsForm.vue?vue&type=script&lang=js&"
export * from "./SettingsForm.vue?vue&type=script&lang=js&"
import style0 from "./SettingsForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports